import { strings, translate } from '../components/internationalization';
export const formFields = {
    signIn: {
        username: {
            labelHidden: false,
            label: translate(strings.LOGIN_EMAIL),
            placeholder: '',
            isRequired: true,
            order: 1,
        },
        password: {
            labelHidden: false,
            label: translate(strings.LOGIN_PASSWORD),
            placeholder: '',
            isRequired: true,
            order: 2,
        },
    },
    signUp: {
        // TODO remove Username and only leave Email
        username: {
            labelHidden: false,
            label: translate("Username"),
            placeholder: '',
            isRequired: true,
            order: 1,
        },
        email: {
            labelHidden: false,
            label: translate("Email"),
            placeholder: '',
            isRequired: true,
            order: 2,
        },
        given_name: {
            labelHidden: false,
            label: translate(strings.LOGIN_NAME),
            placeholder: '',
            isRequired: true,
            order: 3,
        },
        family_name: {
            labelHidden: false,
            label: translate(strings.LOGIN_FAMILY_NAME),
            placeholder: '',
            isRequired: true,
            order: 4,
        },
        password: {
            labelHidden: false,
            label: translate(strings.LOGIN_PASSWORD),
            placeholder: '',
            isRequired: true,
            order: 5,
        },
        confirm_password: {
            labelHidden: false,
            label: translate(strings.LOGIN_CONFIRM_PASSWORD),
            placeholder: '',
            isRequired: true,
            order: 6
        }
    },
    forceNewPassword: {
        password: {
            labelHidden: false,
            placeholder: '',
        },
    },
    resetPassword: {
        username: {
            labelHidden: false,
            label: translate(strings.LOGIN_EMAIL),
            placeholder: '',
            isRequired: true,
            order: 1,
        },
    },
    confirmResetPassword: {
        confirmation_code: {
            labelHidden: false,
            placeholder: '',
            label: translate(strings.LOGIN_CONFIRMATION_CODE),
            isRequired: false,
            order: 1,
        },
        password: {
            labelHidden: false,
            placeholder: '',
            label: translate(strings.LOGIN_NEW_PASSWORD),
            isRequired: false,
            order: 2,
        },
        confirm_password: {
            labelHidden: false,
            label: translate(strings.LOGIN_CONFIRM_PASSWORD),
            placeholder: '',
            order: 3,
        },
    },
    setupTOTP: {
        QR: {
            totpIssuer: 'test issuer',
            totpUsername: 'LOGIN_qr_test_user',
        },
        confirmation_code: {
            labelHidden: false,
            label: translate(strings.LOGIN_CONFIRMATION_CODE),
            placeholder: '',
            isRequired: false,
        },
    },
    confirmSignIn: {
        confirmation_code: {
            labelHidden: false,
            label: translate(strings.LOGIN_CONFIRMATION_CODE),
            placeholder: '',
            isRequired: false,
        },
    },
    confirmSignUp: {
        confirmation_code: {
            labelHidden: false,
            label: translate(strings.LOGIN_CONFIRMATION_CODE),
            placeholder: '',
            isRequired: false,
        },
    },
};
